import { Box, Button, Flex, Text } from '@radix-ui/themes';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '~/components/Icon';
import OnomondoLogo from '~/components/OnomondoLogo';

const StyledGiantText = styled(Text)`
  font-size: 120px;
`;

function NotFound() {
  return (
    <Flex
      direction='column'
      align='center'
      gap='4'
      pt='80px'
    >
      <Flex
        direction='column'
        align='center'
        gap='2'
      >
        <Flex
          align='center'
          gap='1'
        >
          <StyledGiantText weight='bold'>4</StyledGiantText>
          <OnomondoLogo
            size={120}
            animated
            primaryColor='gray'
          />
          <StyledGiantText weight='bold'>4</StyledGiantText>
        </Flex>
        <Text
          size='6'
          weight='medium'
        >
          Oops, page not found
        </Text>
        <Box
          width='270px'
          align='center'
        >
          <Text
            size='2'
            color='gray'
          >
            The page you are looking for doesn’t exist or has been moved.
          </Text>
        </Box>
      </Flex>
      <NavLink to='/'>
        <Button
          variant='outline'
          radius='full'
          color='gray'
          highContrast
        >
          Back to home
          <Icon
            name='arrow-right'
            width={16}
            height={16}
            inline
          />
        </Button>
      </NavLink>
    </Flex>
  );
}

export default NotFound;
